// packages/utils/src/shared/net/isLocalDevHostname.ts

import { isLoopbackHostname } from '../site-hostnames/normalizeSiteHostname';

/**
 * Whether a page's hostname (`window.location.hostname`) is the developer's own machine:
 * `localhost`, `127.0.0.1` or a `*.localhost` subdomain (`.localhost` is a reserved loopback
 * TLD, RFC 6761). Browser code that picks local or production addresses by the page's host
 * asks this, so a page opened on the dev machine by any of its names talks to the dev machine
 * only: tourtask.com's chat, the booking widget's bookings, the Meta connect launcher. Opened at
 * 127.0.0.1, tourtask.com once sent its chat to production's API (2026-10-18).
 */
export function isLocalDevHostname(hostname: string): boolean {
  return isLoopbackHostname(hostname) || hostname.endsWith('.localhost');
}
